import Axios from 'axios'

const getDefaultState = () => {
  return {
    fenicheComments: []
  }
}

const state = getDefaultState()

const mutations = {
  SET_FENICHE_COMMENTS: (state, payload) => {
    state.fenicheComments = payload
  }
}

const actions = {
  async fetchFenicheComments({ commit }, responseToken) {
    await Axios.get(`/1.0/public-responses/${responseToken}/comments`)
      .then(response => {
        commit('SET_FENICHE_COMMENTS', response.data.data)
      })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
